import api from '@/utils/api';

export interface OrderReportRequest {
  from_date: string;
  to_date: string;
  period?: string;
  tags?: string[];
  financial_status?: string;
}

// Summary Report
export async function getOrdersSummary(req: OrderReportRequest) {
  return api.req({
    url: '/reports/orders/summary',
    method: api.Method.POST,
    data: req,
  });
}

// Date-wise Report
export async function getOrdersDateWise(req: OrderReportRequest) {
  return api.req({
    url: '/reports/orders/date-wise',
    method: api.Method.POST,
    data: req,
  });
}

// Tag-wise Report
export async function getOrdersTagWise(req: OrderReportRequest) {
  return api.req({
    url: '/reports/orders/tag-wise',
    method: api.Method.POST,
    data: req,
  });
}

// Agent-wise Report
export async function getOrdersAgentWise(req: OrderReportRequest) {
  return api.req({
    url: '/reports/orders/agent-wise',
    method: api.Method.POST,
    data: req,
  });
}

// Status Matrix Report
export async function getOrdersStatusMatrix(req: OrderReportRequest) {
  return api.req({
    url: '/reports/orders/status-matrix',
    method: api.Method.POST,
    data: req,
  });
}

// ---------------------------------------------------------------------------
// Agent Performance Reports
// ---------------------------------------------------------------------------

export interface AgentReportRequest {
  from_date: string;
  to_date: string;
  lead_bucket?: string;   // "abandoned_cart" | "reorder" | "regular" | undefined = all
  agent_uuid?: string;
}

export async function getAgentLeaderboard(req: AgentReportRequest) {
  return api.req({ url: '/reports/agents/leaderboard', method: api.Method.POST, data: req });
}

export async function getAgentDispositionBreakdown(req: AgentReportRequest) {
  return api.req({ url: '/reports/agents/disposition-breakdown', method: api.Method.POST, data: req });
}

export async function getAgentProducts(req: AgentReportRequest) {
  return api.req({ url: '/reports/agents/products', method: api.Method.POST, data: req });
}

export async function getAgentResponseTime(req: AgentReportRequest) {
  return api.req({ url: '/reports/agents/response-time', method: api.Method.POST, data: req });
}

export async function getAgentProductMatrix(req: AgentReportRequest) {
  return api.req({ url: '/reports/agents/product-matrix', method: api.Method.POST, data: req });
}

// Incentive Leaderboard
export async function getIncentiveLeaderboard(req: { from_date: string; to_date: string }) {
  return api.req({ url: '/reports/agents/incentive-leaderboard', method: api.Method.POST, data: req });
}

// ABC (Abandoned Cart) Report
export async function getAbcReport(req: { from_date: string; to_date: string }) {
  return api.req({ url: '/reports/abc', method: api.Method.POST, data: req });
}
